(() => {
  "use strict";

  const onReady = (callback) => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
      return;
    }

    callback();
  };

  const moveFooterLogoIntoMainContent = () => {
    const footer = document.querySelector("footer.footer");

    if (!footer) {
      return;
    }

    const logoContainer = footer.querySelector(".footer__logo-container");
    const mainContent = footer.querySelector(".footer__main-content");

    if (!logoContainer || !mainContent || logoContainer.parentElement === mainContent) {
      return;
    }

    mainContent.appendChild(logoContainer);
    logoContainer.classList.add("moved");
  };

  const enableHeaderHoverDropdowns = () => {
    const details = document.querySelectorAll(".jm-header-nav__details");

    if (!details.length || window.matchMedia("(hover: none)").matches) {
      return;
    }

    details.forEach((el) => {
      if (el.dataset.jmHoverBound === "true") {
        return;
      }

      let closeTimer;

      const open = () => {
        clearTimeout(closeTimer);
        details.forEach((other) => {
          if (other !== el) {
            other.removeAttribute("open");
          }
        });
        el.setAttribute("open", "");
      };

      const close = () => {
        closeTimer = setTimeout(() => el.removeAttribute("open"), 120);
      };

      el.addEventListener("mouseenter", open);
      el.addEventListener("mouseleave", close);
      el.addEventListener("focusin", open);
      el.addEventListener("focusout", (event) => {
        if (!el.contains(event.relatedTarget)) {
          close();
        }
      });

      el.dataset.jmHoverBound = "true";
    });
  };

  const init = () => {
    document.documentElement.classList.add("jm-js-ready");
    moveFooterLogoIntoMainContent();
    enableHeaderHoverDropdowns();
  };

  onReady(init);

  // Re-run child-theme init when sections are re-rendered in the Theme Editor.
  document.addEventListener("shopify:section:load", init);
})();
